/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
declare global {
    interface Window {
        dataLayer: any;
    }
}
// TODO: Current build require at least one tsx file
export default () => <div />;
